import { DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react";
import { IT, UseReporteHistoricoEstado } from "./UseReporteHistoricoEstado";
import { UseReporteExcel } from "./panelHistoricoEstadoFiltro/UseReporteExcel";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent";
import { PanelHistoricoEquipoFil } from "./panelHistoricoEstadoFiltro/PanelHistoricoEstadoFilt";
import { useState } from "react";

const ReporteHistoricoEstado = () => {
    const { items, filter, loading, pagination, handleResetUpdate, onChangeSearch, onChangeTake, _onkeyUpSearchTable, filter2, buscar, resetFilter2, onChangeComboFilter, getHistoricoEstadoEquipo,onChangeFecha } = UseReporteHistoricoEstado();
    const { descargarReporte } = UseReporteExcel(filter);
    const [openPanelFiltrar, setOpenPanelFiltrar] = useState(false)

    const buttonLeft: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_RELOAD,
            text: "Actualizar",
            onClick: () => {
                handleResetUpdate() 
                getHistoricoEstadoEquipo()
            },
        },
        {
            ...IconHelper.ICON_EXCEL,
            text: "Descargar",
            onClick: () => {
                descargarReporte()
            },
        }
    ];

    const buttonRight: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_BS_FILTER,
            text: "Buscar",
            onClick: () => {
                setOpenPanelFiltrar(true)
            },
        }
    ];

    const _columns = [
        {
            key: "numeracion",
            name: "N°",
            fieldName: "numeracion",
            minWidth: 20,
            maxWidth: 20,
            onRender: (item, index) => {
                const startIndex = (filter.skip ?? 0);
                return <>{startIndex + (index ?? 0) + 1}</>;
            }
        },
        {
            key: "equipo",
            name: "Equipo",
            fieldName: "equipo",
            minWidth: 50,
            maxWidth: 50,
        },
        {
            key: "razon",
            name: "Razón",
            fieldName: "razon",
            minWidth: 150,
            maxWidth: 150
        },
        {
            key: "operador",
            name: "Operador",
            fieldName: "operador",
            minWidth: 120,
            maxWidth: 120,
        },
        {
            key: "turno",
            name: "Turno",
            fieldName: "turno",
            minWidth: 60,
            maxWidth: 60
        },
        {
            key: "horometro",
            name: "Horómetro",
            fieldName: "horometro",
            minWidth: 80,
            maxWidth: 80
        },
        {
            key: "fechaHora",
            name: "Fecha",
            fieldName: "fechaHora",
            minWidth: 120,
            maxWidth: 120
        },
        {
            key: "comentario",
            name: "Comentario",
            fieldName: "comentario",
            minWidth: 100,
            maxWidth: 200
        },
        {
            key: "ubicacion",
            name: "Ubicación",
            fieldName: "ubicacion",
            minWidth: 100,
            maxWidth: 100
        },
        {
            key: "combustible",
            name: "Combustible",
            fieldName: "combustible",
            minWidth: 80,
            maxWidth: 80
        },
        {
            key: "estado",
            name: "Estado",
            fieldName: "estado",
            minWidth: 80,
            maxWidth: 100
        },
        /*  {
             key: "opciones",
             name: "Opciones",
             minWidth: 2,
             maxWidth: 2,
             fieldName: "opciones",
             onRender: (item: any) => renderOpciones(item)
         }, */
    ]

    return (
        <>
            <CabeceraTable
                Titulo={"Equipos Auxiliares"}
                SubTitulo={`Reporte Historial Estados de Equipos`}
                placeholder="Buscar por Equipo"
                componentRef={onChangeSearch}
                onKeyUp={_onkeyUpSearchTable}
            />
            {/* <pre>{JSON.stringify(items, null,2)}</pre> */}
            <TableBaseComponent
                leftBar={buttonLeft}
                rigthBar={buttonRight}
                data={items}
                column={_columns}
                isLoading={loading}
                getPageSize={onChangeTake}
                pagination={pagination}
                layout={DetailsListLayoutMode.justified}
            />
            <PanelHistoricoEquipoFil
                filter2={filter2}
                isOpen={openPanelFiltrar}
                onChangeComboFilter={onChangeComboFilter}
                resetFilter2={resetFilter2}
                onChangeFecha={onChangeFecha}
                buscar={buscar}
                onDismiss={() => setOpenPanelFiltrar(false)}
            />
        </>
    )
}

export { ReporteHistoricoEstado }